import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function loginByCode(code) {
  return request({
    url: '/admin/loginByCode',
    method: 'post',
    data: {
      code
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateCurUserPasswd(data) {
  return request({
    url: '/admin/updateCurUserPassword',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

export function allocAndroidGame(data) {
  return request({
    url: '/admin/androidGame/update',
    method: 'post',
    data: data
  })
}

export function allociOSGame(data) {
  return request({
    url: '/admin/iOSGame/update',
    method: 'post',
    data: data
  })
}

export function getAndroidGameByAdmin(id) {
  return request({
    url: '/admin/androidGame/' + id,
    method: 'get'
  })
}

export function getiOSGameByAdmin(id) {
  return request({
    url: '/admin/iOSGame/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js